module.exports = __webpack_public_path__ + "static/media/zh-CN.41815c80.svg";